import request from '@/utils/request'


// 查询森林分类列表
export function listCategory(query) {
  return request({
    url: '/forest/category/list',
    method: 'get',
    params: query
  })
}

// 查询森林分类分页
export function pageCategory(query) {
  return request({
    url: '/forest/category/page',
    method: 'get',
    params: query
  })
}

// 查询森林分类详细
export function getCategory(data) {
  return request({
    url: '/forest/category/detail',
    method: 'get',
    params: data
  })
}

// 新增森林分类
export function addCategory(data) {
  return request({
    url: '/forest/category/add',
    method: 'post',
    data: data
  })
}

// 修改森林分类
export function updateCategory(data) {
  return request({
    url: '/forest/category/edit',
    method: 'post',
    data: data
  })
}

// 删除森林分类
export function delCategory(data) {
  return request({
    url: '/forest/category/delete',
    method: 'post',
    data: data
  })
}
